import React, { useEffect } from 'react';
import './navtitle.css';
import ReactTypingEffect from 'react-typing-effect';
import Aos from "aos";
import "aos/dist/aos.css";



function Navtitle() {

    useEffect(() => {
        Aos.init({duration: 2000});
    }, [])

    return (
        <div id="home" className="description" >
                <h1 data-aos="flip-left" className="type" ><span className="capture">Karibu sana,</span><br/><span>
                 <ReactTypingEffect
                 text={["Tunatengeneza", "Tunatoa free", "Gharama zetu" ]}
                 />  <br />
                 <ReactTypingEffect
                 text={["Websites kali.", "Hosting", "Ni nafuu saana" ]}
                 cursorRenderer={cursor => <h3>{cursor}</h3>}
                 displayTextRenderer={(text, i) => {
                     return (
                         <h3>
                             {text.split('').map((char, i) => {
                                 const key = `${i}`;
                                 return (
                                     <span 
                                     key={key}
                                     style={i%2 === 0 ? { color: 'red'} : {} }
                                     >{char}</span>
                                 )
                             })}
                         </h3>
                     )
                 }}
                 />  
               </span>
        </h1> 
         <h2 data-aos="flip-left" className="pilar" >Jipatie website bora kwa bei nafuu</h2>
        
    
            
        </div>
    )
}

export default Navtitle
